import Route from '@ember/routing/route';

export default class ForgotPasswordConfirmationRoute extends Route {}
